import Validator from '@shared/validatorjs/src/validator'
import { UpdateSettingsRequest, UpdateField } from './../settings.actions'
import { getFormsState } from './../../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getSettingsState } from './../settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-gis-settings',
  templateUrl: './gis-settings.component.html',
  styleUrls: ['./gis-settings.component.css'],
})
export class GisSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')

    const rules = {
      gisServerUrl: 'required',
      gisWorkspace: 'required',
      gisExtent: 'required',
      gisBaseLayer: 'required',
      gisPointLayer: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      gisServerUrl: 'gis server url',
      gisWorkspace: 'gis workspace',
      gisExtent: 'gis extent',
      gisBaseLayer: 'gis base layer',
      gisPointLayer: 'gis point layer',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateSettingsRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
